import { Component, Input, OnInit } from '@angular/core';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { ApprenantService } from '../../../services/apprenant/apprenant.service';
import { SessionService } from '../../../services/session/session.service';

@Component({
  selector: 'ags-session-habilitation',
  templateUrl: './session-habilitation.component.html',
  styleUrls: ['./session-habilitation.component.scss']
})
export class SessionHabilitationComponent implements OnInit {
  public expandMode: number = PanelBarExpandMode.Single;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  public idSession;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  public listApprenant: any;
  public dataProduitHabilitation: any;
  public dataApprenantHabilitation: any;
  public habilitationApprenant: any;
  public habilitationInfo: any;

  constructor(private apprenantService: ApprenantService, private sessionService: SessionService) {}

  ngOnInit() {
    this.getApprenantsSession(this.idSession);
    this.getHabilationInfo(this.idSession);
  }

  // Liste Apprenant
  getApprenantsSession(idSession) {
    this.apprenantService.getApprenantBySession(idSession).subscribe((apprenantsSessionData: any) => {
      this.listApprenant = apprenantsSessionData.filter(el => el.id_apprenant != null);
    });
  }
  getHabilationInfo(idSession) {
    // Récupérer les informations de l'habilitation du produit
    this.sessionService.getHabilationBySession(idSession).subscribe(res => {
      this.dataProduitHabilitation = res;
    });
    // Récuppérer les informations des apprenants non fantôme
    this.sessionService.getSessionApprenantHabilitation(idSession).subscribe(res => {
      this.dataApprenantHabilitation = res;
    });
  }

  getHabilitationApprenant($event) {
    try {
      const apprenantSession = $event.items.find(el => el.expanded);

      const habdef = this.dataApprenantHabilitation.habilitations.find(
        hab => hab.habilitation?.indices && Object.keys(hab.habilitation.indices).length > 0
      )?.habilitation.indices || {};
      
      const defaultValues = {
        ouvrage: null,
        indications: "",
        selectionne: false
      };
  
      for (let role in habdef) {
          if (habdef.hasOwnProperty(role)) {
              for (let id in habdef[role]) {
                  if (habdef[role].hasOwnProperty(id)) {
                      const element = habdef[role][id];
                      // Vérification des propriétés et de leurs valeurs
                      for (let key in defaultValues) {
                          if (element[key] !== defaultValues[key]) {
                                element[key] == defaultValues[key]
                          }
                      }
                  }
              }
          }
      }
  
      this.dataApprenantHabilitation.habilitations.forEach(hab => {
        if (hab.habilitation?.indices && Object.keys(hab.habilitation.indices).length === 0) {
          hab.habilitation.indices = habdef;
        }
      });

      if (!this.dataApprenantHabilitation || !this.dataApprenantHabilitation.habilitations) {
        console.error('dataApprenantHabilitation is undefined or invalid');
        return;
      }      
      
      if (apprenantSession) {
        this.habilitationApprenant = this.dataApprenantHabilitation.habilitations.find(
          el => Number(el.id) === Number(apprenantSession.id)
        );
      }
      
      this.habilitationInfo = {
        ...this.dataApprenantHabilitation.reglages,
        type: this.dataProduitHabilitation[0]?.habilitation?.type || null
      };
      
    } catch (error) {
      // Debugging information
      console.error('Error in getHabilitationApprenant:', error);
      console.error('this.dataApprenantHabilitation', this.dataApprenantHabilitation);
      console.error('this.dataProduitHabilitation', this.dataProduitHabilitation);
    }
  }
}
